import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import { useState } from 'react';
import Toast from '../../../components/ToastNotification';
import { useUploadStatusMutation } from '../api/chatApi';

const UploadModal = ({ session, onClose }) => {

  const [file, setFile] = useState(null);
  const [statusText, setStatusText] = useState('');
  const [uploadStatusApi] = useUploadStatusMutation();

  const handleBrowsePicture = () => document.getElementById("fileInput").click();

  const handleFileChange = (e) => {
    const selectedFile = e.target?.files?.[0];

    if (!selectedFile) return;

    const allowedTypes = ['image/', 'video/']
    if (!allowedTypes.some(type => selectedFile.type.startsWith(type))) {
      Toast.error('Only image or video files are allowed')
      return
    }

    setFile(selectedFile);
  }

  const submitHandler = async() => {
    try {
        if (!file && !statusText) {
            Toast.error('Please select a file or enter status text to upload.');
            return;
        }

        const formData = new FormData();
        formData.append('user_id', session?.user_id);
        if (statusText) formData.append('text', statusText);
        if (file) {
          formData.append('status', file);
          formData.append('status_type', file.type.startsWith('image/') ? 'image' : 'video');
        }

        await uploadStatusApi(formData).unwrap();

        Toast.success('Status uploaded successfully!');
        onClose();
    } catch (error) {
        Toast.error(error?.data?.message || 'Failed to upload status. Please try again.');
    }
  }

  return (
    <div className='overlay' onClick={onClose}>
      <div className='status_content_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>  
          <h2>Upload Status</h2>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>
        {/* <p>Text becomes a caption when media is added otherwise, it’s posted as text only.</p> */}

        <div className="content_body">
            <div>
              <div className='text-area-section'>
                {/* <label htmlFor="name">Status Text or Caption</label> */}
                <p>Status Text or Caption</p>
                <textarea
                  placeholder="Write something..."
                  type="text"
                  name="name"
                  value={statusText}
                  onChange={(e) => setStatusText(e.target.value)}
                  style={{border: '1px solid #ccc', padding: '10px', fontSize: '16px'}}
                />
              </div>
              <div className='media-upload-section'>
                {/* <label htmlFor="file">Select Media</label> */}
                <div className='section' style={{background: '#fff'}} onClick={handleBrowsePicture}>
                  <img src="/upload.png" alt="" />
                </div>
                <input
                  type="file"
                  name="file"
                  style={{ display: 'none' }}
                  id="fileInput"
                  accept="image/*,video/*"
                  onChange={handleFileChange}
                />
                {/* <button onClick={handleBrowsePicture} className='browse-btn'>Browse File</button> */}
              </div>
              {file && 
                <div className='file-name-box'>
                  <span className='file-name'>{file.name}</span>
                  <span className='delete-icon' onClick={() => setFile(null)}>
                    <img src="/delete.png" alt="" />
                  </span>
                </div>
              }
            </div>
            <div className='layout_footer'>
              <button className='save-btn' onClick={submitHandler}>Upload</button>
              <button onClick={onClose} className='cancel-btn'>Cancel</button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default UploadModal;
